module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_ir-fc0e92e86fc20b1593d0ee88dbab7154.jpg";